import React from 'react';
import { Link } from 'react-router-dom';

const Nav = () => (
  <nav className="fixedNav">
    <div className="home">
      <Link to="/">Home</Link>
    </div>
    <div className="navLink" />
    <div className="next">
      <Link
        to="/cases/case1"
      >
        Case Study →
      </Link>
    </div>
  </nav>
);

export default Nav;



// WEBPACK FOOTER //
// ./src/Modules/AboutMe/Nav.js